var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice-message",on:{"click":_vm.getNotice}},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/images/nav-notice-icon.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }